import { useLocation } from "react-router-dom";
import { MainSidebar } from "@/modules/main-sidebar";
import { Header } from "@/modules/header";
import { FloatingChatWidget } from "@/modules/safecheck/components/messaging/FloatingChatWidget";
import { useMessagingOptional } from "@/modules/safecheck/messaging/MessagingProvider";
import { SidebarProvider, useSidebar } from "./SidebarProvider";
import { cn } from "@/shared/lib/cn";

type DashboardShellProps = {
  children: React.ReactNode;
};

function DashboardShellContent({ children }: DashboardShellProps) {
  const { isOpen, close } = useSidebar();
  const location = useLocation();
  const messaging = useMessagingOptional();
  const isOnMessagingPage = location.pathname === "/dashboard/messaging";
  const hasFloatingChat =
    Boolean(messaging) &&
    messaging.floatingState !== "hidden" &&
    !isOnMessagingPage;

  return (
    <div className="flex min-h-screen bg-background">
      {isOpen && (
        <button
          type="button"
          aria-label="Close sidebar"
          className="fixed inset-0 z-40 bg-black/40 lg:hidden"
          onClick={close}
        />
      )}

      <MainSidebar />

      <div className="flex min-w-0 flex-1 flex-col">
        <Header />
        <main
          className={cn(
            "min-w-0 flex-1 px-3 pt-2 sm:px-5 md:px-6 lg:px-8",
            hasFloatingChat
              ? messaging?.floatingState === "expanded"
                ? "pb-[min(70vh,520px)] sm:pb-[min(70vh,520px)]"
                : "pb-24"
              : "pb-6 sm:pb-7 lg:pb-8",
          )}
        >
          {children}
        </main>
      </div>
      <FloatingChatWidget />
    </div>
  );
}

export function DashboardShell({ children }: DashboardShellProps) {
  return (
    <SidebarProvider>
      <DashboardShellContent>{children}</DashboardShellContent>
    </SidebarProvider>
  );
}
